import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=d54bd91a&"
import script from "./EditAddress.vue?vue&type=script&lang=js&"
export * from "./EditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports